export const TRANSLATIONS_DIR_NAMESPACE = "translations";
export const TRANSLATION_ROUTE = `/${TRANSLATIONS_DIR_NAMESPACE}`;
export const DEFAULT_LOCALE = "en-US";
export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";
export const TPS_USER_AUTHENTICATION_SIGNAL =
  "TPSStaffAugmentation_userIsAuthenticated";
export const LOGGING_OUT = "TPSStaffAugmentation_loggingOut";
export const FALSE = "false";
export const TRUE = "true";

export const TASK_TEST_RECORD_COUNT = 50;
export const PAGE_SIZE = 15;

export enum PAGE_TITLE {
  TAGS = "tags",
  TASKS = "tasks",
  SECURITY_TEAMS = "security_teams",
}

export enum USER_ACTIONS {
  CREATE = "create",
  GET = "get",
  EDIT = "edit",
  DELETE = "delete",
}
